import AppModule from "@/app/modules/module"
import Guards from "@/app/middleware/guards";
import {webWorker} from '@/app/middleware/register'
import WorkerSession from './store/worker-session'

export default new AppModule('w-auth')
    .store([WorkerSession])
    .routers([
        {
            path: '/worker/',
            component: AppModule.layout.FullLayout,
            beforeEnter: Guards([webWorker]),
            children: [
                {
                    path: 'login',
                    name: 'worker.login',
                    component: () => import('./views/login'),
                    meta: {bodyClass: 'body-login', title: 'Backstage | 職人ログイン'}
                },
                {
                    path: 'register',
                    name: 'worker.register',
                    component: () => import('./views/register'),
                    meta: {bodyClass: 'body-login', title: 'Backstage | 会社登録する'}
                },
                {
                    path: 'confirm/change-mail',
                    name: 'worker.confirm.change-mail',
                    component: () => import('./views/change-email'),
                    meta: {bodyClass: 'body-login', title: 'Backstage - Confirm change email'},
                },
                {
                    path: 'registed',
                    name: 'worker.registed',
                    component: () => import('./views/registed'),
                    meta: {bodyClass: 'body-login', title: 'Backstage | 会社登録する'}
                },
                {
                    path: 'active-acount-worker',
                    name: 'worker.active-acount-manager',
                    component: () => import('./views/active-account'),
                    meta: {bodyClass: 'body-login', title: 'Backstage - Register'},
                },
                {
                    path: 'forget-password',
                    name: 'worker.forget-password',
                    component: () => import('./views/forget-password'),
                    meta: {bodyClass: 'body-login', title: 'Backstage | 会社のパスワードを忘れた'},
                },
                {
                    path: 'change-password',
                    name: 'worker.change-password',
                    component: () => import('./views/change-password'),
                    meta: {bodyClass: 'body-login', title: 'Backstage | パスワードを変更する'},
                },
            ]
        }
    ])
